import { AspectRatio } from "@mui/joy";
import { Box, Grid, Typography } from "@mui/material";
import { useLocation, Link as ReactLink } from "react-router-dom";
import data from "../../Assets/data/energysystems.json";

const ProjectPage = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const projectId =
    pathname.split("/")[location.pathname.split("/").length - 1];
  const currentProject = data.find((project) => {
    return project.url === projectId ? project : null;
  });
  return (
    <>
      <Box
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingBottom: "2em",
        }}
      >
        <Box
          style={{
            width: "100%",
            background:
              "linear-gradient(180deg, #004C98 0%, rgba(90, 139, 188, 0.646736) 38.69%, rgba(255, 255, 255, 0) 100%)",
          }}
        >
          <Typography
            style={{
              padding: "32px",
              width: "100%",
              justifyContent: "flex-end",
              display: "flex",
              boxSizing: "border-box",
              marginRight: "32px",
              textAlign: "end",
            }}
            fontSize="32px"
            fontWeight={600}
          >
            {currentProject.title}
          </Typography>
        </Box>
        <Box
          style={{
            maxWidth: "960px",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid container>
            <Grid xs={3} item>
              <Typography fontWeight={600} fontSize="28px">
                DIRECTORY
              </Typography>
              {data.map((project, i) => {
                return pathname.split("/")[
                  location.pathname.split("/").length - 1
                ] === project.url ? null : (
                  <ReactLink
                    key={i}
                    to={{ pathname: `/projects/${project.url}` }}
                    style={{
                      textDecoration: "none",
                      color: "black",
                    }}
                  >
                    <Typography
                      noWrap
                      style={{
                        padding: "6px 8px",
                      }}
                      fontWeight={600}
                      fontSize="18px"
                    >
                      {project.title.slice(0, 28) + "..."}
                    </Typography>
                  </ReactLink>
                );
              })}
              <Typography
                fontWeight={600}
                fontSize="24px"
                style={{ marginTop: "80px" }}
              >
                PROJECT MEMBERS
              </Typography>
              {currentProject.projectmembers.map((member, i) => {
                return (
                  <Box style={{ padding: "6px 8px" }} key={i}>
                    <Typography fontWeight={600}>{member.name}</Typography>
                    <Typography>{member.role}</Typography>
                  </Box>
                );
              })}
            </Grid>
            <Grid
              item
              xs={9}
              style={{ padding: "0px 24px", boxSizing: "border-box" }}
            >
              <AspectRatio ratio="16/9">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/Images/Projects/" +
                    currentProject.image
                  }
                  alt="Project"
                  style={{ width: "-webkit-fill-available" }}
                />
              </AspectRatio>
              <Typography
                style={{ marginTop: "12px" }}
                fontWeight={600}
                fontSize="20px"
              >
                {currentProject.title}
              </Typography>
              <Typography fontStyle="italic" fontSize="12px">
                {currentProject.funded}
              </Typography>
              <Typography style={{ marginTop: "12px", textAlign: "justify" }}>
                {currentProject.description}
              </Typography>
              {currentProject.projectoutput ? (
                <Typography
                  fontWeight={600}
                  fontSize="20px"
                  style={{ marginTop: "12px", marginBottom: "6px" }}
                >
                  Project Output
                </Typography>
              ) : null}
              {currentProject.projectoutput &&
                currentProject.projectoutput.map((output, i) => {
                  return (
                    <Box style={{ marginBottom: "8px" }} key={i}>
                      <Typography fontWeight={600}>
                        {output.artifact}
                      </Typography>
                      {output.description ? (
                        <Typography>{output.description}</Typography>
                      ) : null}
                    </Box>
                  );
                })}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default ProjectPage;
